import { RepositoryFactory } from '../repositories/RepositoryFactory';
import { IAuthRepository } from '../repositories/interfaces/IAuthRepository';
import { IReportRepository } from '../repositories/interfaces/IReportRepository';
import { IZoneRepository } from '../repositories/interfaces/IZoneRepository';

/**
 * Service centralisé pour accéder aux repositories
 * Simplifie l'utilisation et permet un contrôle centralisé
 */
export class RepositoryService {
  static get auth(): IAuthRepository {
    return RepositoryFactory.getAuthRepository();
  }

  static get reports(): IReportRepository {
    return RepositoryFactory.getReportRepository();
  }

  static get zones(): IZoneRepository {
    return RepositoryFactory.getZoneRepository();
  }

  /**
   * Informations sur l'environnement actuel
   */
  static get environment() {
    return {
      mode: RepositoryFactory.currentMode,
      isProduction: RepositoryFactory.isProductionMode,
      isLocal: RepositoryFactory.isLocalMode,
    };
  }

  /**
   * Méthode pour logger les informations de débogage
   */
  static logEnvironmentInfo(): void {
    // Environment info logging removed
  }
}

// Auto-log en mode développement
if (import.meta.env.DEV) {
  RepositoryService.logEnvironmentInfo();
}